<template>
  <div class="animated fadeIn">
    <div class="container" style="min-width: 1800px;">
      <clientselection
        v-if="isMSMUser || hasDashboardCustomerSelection()"
        v-on:clientselectionchanged="onClientSelectionChanged"
      />

      <div class="row">
        <div class="col-xl">
          <div ref="cockpit" v-bind:class="{ spinner: isLoading }">
            <div class="col-md-auto excelButtonTooltip" >

<!--          <b-form-radio-group v-model="theme.selected"
                                  :options="theme.options"
                                  class="app-ctrl"
                                  button-variant="outline-primary"
                                  size="sm"
                                  name="radio-btn-outline"
                                  v-on:change="themeChanged"
                                  buttons>
              </b-form-radio-group> -->

              <b-form-radio-group v-model="displayMode.selected"
                                  :options="displayMode.options"
                                  button-variant="outline-primary"
                                  v-if="tabIndex > 0 && tabIndex < 3 && !displayMode.hideSwitch"
                                  size="sm"
                                  name="radio-btn-outline"
                                  v-on:change="displayModeChanged"
                                  buttons>
              </b-form-radio-group>

              <b-button v-if="hasFileImport && localUserProfile.Permissions.includes('Import')" 
                        id="importButton" size="sm" variant="primary" to="cx/importmarginfile"
                        class="app-ctrl">
                <font-awesome-icon icon="file-import" /> {{ $t('Webportal.Import') }}
              </b-button>

              <b-button v-if="displayMode.selected === 'tiles' || tabIndex === 3"
                        id="excelButton"
                        class="excelButton"
                        variant="success"
                        @click="excelExport()"
                        v-b-tooltip.hover.top="'Exploration-Export'"
                        size="sm">
                <font-awesome-icon icon="file-excel" /> {{ $t('Webportal.CX.Export') }}
              </b-button>

              <b-dropdown v-else
                          class="exportGroup"
                          right
                          split 
                          variant="success"
                          @click="excelExport('all')"
                          :disabled="isLoadingExport" 
                          v-b-tooltip.hover.top="$t('Webportal.CX.ExportAllButton')"
                          size="sm">
                <template #button-content>
                  <font-awesome-icon icon="file-excel" /> {{ $t('Webportal.CX.Export') }}
                </template>
                <b-dropdown-item-button @click="excelExport('selected')">                  
                  <font-awesome-icon icon="file-excel" /> {{$t('Webportal.CX.ExportSelectedButton')}}
                </b-dropdown-item-button>
              </b-dropdown>

            </div>

            <b-card no-body class="mb-5">
              <b-tabs small class="app-ctrl app-ctrl-tabs"
                      style="100%"
                      card
                      v-if="ClientSelected"
                      v-model="tabIndex">
                
                <!-- Map Tab (disabled ???) -->
                <b-tab  lazy class="app-ctrl"
                        :title="$t('Webportal.CX.Global')"
                        v-if="!showCountries"
                        :key="1"
                        title-item-class="disabledTab" />

                <!-- Countries Tab -->
                <b-tab  v-if="showCountries" class="app-ctrl"
                        :key="2"
                        lazy
                        :title="$t('Webportal.CX.Global')">
                  <cxGlobal title-item-class
                            :countryValues="CountryValues"
                            :colorRange="FallbackColorRange"
                            @drilldownToRetailer="drilldownToRetailer" />
                </b-tab>

                <!-- Markets Tab (disabled ???) -->
                <b-tab  lazy class="app-ctrl"
                        :title="$t('Webportal.CX.Market')"
                        v-if="!CountryValues || !showCountries"
                        title-item-class="disabledTab" />

                <!-- Markets Tab -->
                <b-tab  v-else-if="showCountries" class="app-ctrl"
                        active
                        lazy
                        :title="$t('Webportal.CX.Market')" >
                  <cxMarket ref="market"
                            :countryValues="CountryValues"
                            :displayMode="displayMode"
                            :clientId="ClientSelected"
                            :overall="marketOverall"
                            :colorRange="FallbackColorRange"
                            :theme="theme.selected"
                            @drilldownToRetailer="drilldownToRetailer" />
                </b-tab>

                <!-- Retailers Tab (disabled ???) -->
                <b-tab  lazy class="app-ctrl"
                        :title="$t('Webportal.CX.Retailer')"
                        v-if="!showRetailer"
                        title-item-class="disabledTab" />

                <!-- Retailers Tab -->
                <b-tab  :title="$t('Webportal.CX.Retailer')"
                        v-if="showRetailer" class="app-ctrl"
                        id="retailerTab">
                  <cxRetailer ref="retailer"
                              :key="retailerReloadKey"
                              :retailerValues="RetailerValues"
                              :colorRange="FallbackColorRange"
                              :defaultLogo="DefaultLogo"
                              :clientId="ClientSelected"
                              :countryId="CountrySelected"
                              :overall="retailerOverall"
                              :scoreId="scoreId"
                              :displayMode="displayMode"
                              :theme="theme.selected"
                              @drilldownToDashboard="drilldownToDashboard"
                              @loadData="getRetailer" />
                </b-tab>

                <!-- Details Tab / No Dashboard -->
                <b-tab  :title="$t('Webportal.CX.Dashboard')"
                        v-if="!showDashboard" class="app-ctrl"
                        title-item-class="disabledTab" />
                
                <!-- Details Tab / Dashboard -->
                <b-tab  :title="$t('Webportal.CX.Dashboard')" class="app-ctrl"
                        v-if="showDashboard">
                  <cxDashboard  v-if="DashboardData"
                                :dashboardData="DashboardData"
                                :clientLocationId="RetailerSelected"
                                :defaultLogo="DefaultLogo"
                                :colorRange="FallbackColorRange"
                                :theme="theme.selected"
                                :retailerSelected="RetailerSelected" />
                </b-tab>

              </b-tabs>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from "@/mixins/AppConfig-APP_TARGET";
import CancelToken from "@/mixins/CancelToken";
import DownloadFileMixin from '@/mixins/DownloadFileMixin';
import i18n from '@/i18n';

import EventBus from "@/services/EventBus.js";
import AuthenticationService from "@/services/AuthenticationService";
import DashboardService from "@/services/DashboardService";
import AdministationService from "@/services/AdministationService";

import cxGlobal from "@/components/CX/Global";
import cxMarket from "@/components/CX/Market";
import cxRetailer from "@/components/CX/Retailer";
import cxDashboard from "@/components/CX/Dashboard";

import clientselection from "./ClientSelection";

export default {
  name: "CX",

  mixins: [AppConfig, CancelToken, DownloadFileMixin ],

  components: {
    clientselection,
    cxGlobal,
    cxMarket,
    cxRetailer,
    cxDashboard
  },

  watch: {
    tabIndex: {
      handler(newVal, oldVal) {
        this.changeHistory(newVal);
      }
    },
    RetailerSelected: {
      handler(newVal, oldVal) {
        this.DashboardData = null;
      }
    }
  },

  created() {
    if (!this.isMSMUser) {
      this.ClientSelected = AuthenticationService.localUserProfile.ClientId;
      this.getClientSettings();
    }

    EventBus.$on("LocalizationChanged", this.reloadCurrentTab);
    EventBus.$on("GetCX_Filter", this.getCX_Filter);
    EventBus.$on("Score_Changed", (selectedScoreId) => {
      this.scoreId = selectedScoreId;
      this.getDealer(selectedScoreId);
    })
  },

  mounted() {
    this.initializeTheme();

    this.getCountries();

    // Reset history state to prevent funny behavior
    window.history.replaceState(null, null);

    // Handle back clicks for history
    window.addEventListener("popstate", this.changeHistoryHandler);
  },

  beforeDestroy() {
    window.removeEventListener("popstate", this.changeHistoryHandler);
    EventBus.$off("LocalizationChanged", this.reloadCurrentTab);
    EventBus.$off("GetCX_Filter", this.getCX_Filter);
    EventBus.$off("Score_Changed");
  },

  data() {
    return {
      DefaultLogo: null,

      ColorRange: null,
      CountryValues: {},
      RetailerValues: {},
      DashboardData: null,

      ClientSelected: null,
      CountrySelected: null,
      RetailerSelected: null,

      showCountries: true,
      showRetailer: false,
      showDashboard: false,

      marketOverall: [],
      retailerOverall: [],

      isLoadingExport: false,
      isLoadingSettings: false,
      isLoadingCountries: false,
      isLoadingDealer: false,
      isLoadingRetailer: false,
      retailerReloadKey: 0,
      scoreId: null,

      optionsCancelToken: null,

      tabIndex: 0,

      toolTipDelay: { delay: { show: 500, hide: 100 } },

      // The original paging is in Retailer, but it is needed to store temporarily
      pageSize: 999, // Number of items on one page of the table
      selectedPage: 1, // Number of the page, that is currently visible
      searchText: { Value: null, Changed: false },

      FallbackColorRange: [
        {
          Minimum: 0,
          Maximum: 69.99,
          Color: "#f54052",
          Smiley: 'frown-open'
        },
        {
          Minimum: 70,
          Maximum: 89.99,
          Color: "#FFD700",
          Smiley: 'meh'
        },
        {
          Minimum: 90,
          Maximum: 100,
          Color: "#36c259",
          Smiley: 'grin'
        }
      ],

      // Show Tiles or Table view
      displayMode: {
        hideSwitch: false,
        selected: 'table',
        options: [
          { text: this.$t('Webportal.Tiles'), icon: 'tiles', value: 'tiles', disabled: false },
          { text: this.$t('Webportal.Table'), icon: 'table', value: 'table', disabled: false }
        ]
      },
    };
  },

  methods: {
    excelExport(param) {
      // Use AG-Grid export
      this.isLoadingExport = true;
      if (this.tabIndex < 3 && param && this.displayMode.selected === 'table') {
        try {
          if (this.tabIndex === 1) {
            this.$refs.market.exportExcel({ table: 'market', mode: param });
          } else if (this.tabIndex === 2) {
            this.$refs.retailer.exportExcel({ table: 'retailer', mode: param });
          }
        } catch (err) {
          console.error(err)
        } finally {
          this.isLoadingExport = false;
        }
        return;        
      }

      // Workaround: The tooltip doesn't hide as the button is disabled and disabled elements
      // can't be (un)focused - parent elements are a bit iffy in this specific case
      // this.$root.$emit('bv::hide::tooltip', 'excelButton')
      this.optionsCancelToken = this.initCancelToken(this.optionsCancelToken);

      // Filter depends on selected tab
      const filter = {
        "client-id":  this.ClientSelected,
        "country-id": (this.tabIndex >= 2) ? this.CountrySelected : null,
        "clientlocation-id": (this.tabIndex >= 3) ? this.RetailerSelected : null,
        "localization-id": i18n.locale
      };

      // Set spinning cursor
      document.body.style.cursor = "progress";

      DashboardService.getCxReport(filter, this.optionsCancelToken)
        .then(response => this.downloadFile(response))
        .catch(error => console.warn(error))
        .finally(() => {
          this.isLoadingExport = false;
          document.body.style.cursor = null;
        });
    },

    changeHistoryHandler(event) {
      this.changeHistory(event.state);
    },

    changeHistory(tabId) {
      // Handle programatically set tab index:
      // The state was set first and tabIndex is changed afterwards
      // tabIndex will call this function again and we can filter it:
      if (tabId == null || window?.history?.state?.tabId === tabId) return;

      // Handle popstate by setting old state
      if (typeof tabId === "object") {
        window.history.replaceState(tabId, null);
        this.tabIndex = tabId.tabId;
        return;
      }

      // Handle drilldown and clicking on tab by replacing state (reset)
      window.history.pushState({ tabId }, null);
      this.tabIndex = tabId;
    },

    drilldownToRetailer(countryId, overall = undefined) {
      this.retailerReloadKey++;
      this.showRetailer = true;
      this.showDashboard = false;
      this.CountrySelected = countryId;

      if (overall === undefined) {
        let finding = this.CountryValues.AggregatedData.find(x => x.CountryId == countryId);
        overall = JSON.parse(JSON.stringify(finding));
      }

      this.retailerOverall = [overall];
      this.tabIndex = 2;
      return this.getRetailer(null, 1, this.pageSize);
    },

    drilldownToDashboard(clientLocationId) {
      this.showDashboard = true;
      try {
        this.RetailerSelected = clientLocationId;
      } catch (err) {
        console.warn(err);
      }

      this.tabIndex = 3;
      document.activeElement.blur();
      return this.getDealer(-1);
    },

    // CX RM: CX TODO - Rework - Filter for history
    getCX_Filter(callback) {
      if (typeof callback !== "function") return;

      callback({
        client: this.ClientSelected,
        locations: this.RetailerSelected,
        countries: this.CountrySelected
      });
    },

    reloadCurrentTab(localizationId) {
      // (Re)load data depending on current tabIndex
      switch (this.tabIndex) {
        case 0:
        case 1:
          return this.getCountries();

        case 2:
          return this.getRetailer();

        case 3:
          return this.getDealer(-1);

        default:
          return Promise.reject();
      }
    },

    getCountries() {
      if (this.ClientSelected == null) return;

      this.isLoadingCountries = true;
      this.CountryValues = {};
    
      this.optionsCancelToken = this.initCancelToken(this.optionsCancelToken);
      return DashboardService.getCXMarket(
          {
            ClientId: this.ClientSelected
          },
          {},
          this.optionsCancelToken
        )
        .then(response => {
          // If no data show nothing
          if (response?.data?.AggregatedData?.length <= 0)
            return;

          this.CountryValues = response.data;
        })
        .finally(() => {
          this.isLoadingCountries = false;
        });
    },

    getRetailer(searchText, selectedPage, pageSize) {
      this.RetailerValues = {};

      if (this.searchText.Value === searchText) {
        this.searchText.Changed = false;
      } else {
        this.searchText.Value = searchText;
        this.searchText.Changed = true;
      }

      if (this.searchText.Changed) selectedPage = 1;
      if (selectedPage) this.selectedPage = selectedPage;
      if (pageSize) this.pageSize = pageSize;

      if (this.CountrySelected == null)
        return;

      this.optionsCancelToken = this.initCancelToken(this.optionsCancelToken);

      this.isLoadingRetailer = true;
      return DashboardService.getCXDealers(
          {
            ClientId:   this.ClientSelected,
            CountryId:  this.CountrySelected
          },
          {
            searchText: searchText,
            page:       selectedPage || this.selectedPage,
            pageSize:   this.pageSize
          },
          this.optionsCancelToken
        )
        .then(response => {
          // If no data show nothing
          if (!response.data || response.data == "" || response.data.AggregatedData?.length <= 0)
            return;

          // Needed :/
          let data = response.data;
          for (const item of data.AggregatedData) {
            if (item.Explorations && item.Explorations.ApiExplorations) {
              item.Explorations.Google      = [...item.Explorations.ApiExplorations.filter(x => x.name== 'Google')];
              item.Explorations.Autoscout24 = [...item.Explorations.ApiExplorations.filter(x => x.name== 'Auto Scout 24')];
              item.Explorations.Mobile_de   = [...item.Explorations.ApiExplorations.filter(x => x.name== 'Mobile.de')];
              item.Explorations.Seobility   = [...item.Explorations.ApiExplorations.filter(x => x.name== 'Seobility_en')];
              item.Explorations.Seobility2  = [...item.Explorations.ApiExplorations.filter(x => x.name== 'Seobility2_en')];
            }
          } 

          this.RetailerValues = data;
        })
        .finally(() => {
          this.isLoadingRetailer = false;
        });
    },

    getDealer(scoreId) {
      if (this.RetailerSelected == null || this.CountrySelected == null || this.ClientSelected == null) {
        this.drilldownToRetailer(this.CountrySelected);
        return Promise.resolve();
      }

      this.isLoadingDealer = true;
      

      this.optionsCancelToken = this.initCancelToken(this.optionsCancelToken);

      return DashboardService.getDealer(
          this.RetailerSelected,
          this.optionsCancelToken,
          scoreId
        )
        .then(response => {
          this.DashboardData = null;
          if (response.data) {
            this.DashboardData = response.data;
          } else if (this.isMSMUser) {
            // Redirect to Market needed
            // this.drilldownToRetailer(this.CountrySelected);
          }
        })
        .finally(() => {
          this.isLoadingDealer = false;
        });
    },

    // ***********************************************************
    // HTML Events
    // ***********************************************************

    // Client Selection (for MSMUser)
    // ******************************
    onClientSelectionChanged(clientSettings) {
      if (clientSettings) {
        this.ClientSelected = clientSettings?.ClientId || null;
      }

      // Reset all slections after client change
      this.tabIndex = 1;
      this.showRetailer = false;
      this.showDashboard = false;
      this.showCountries = true;

      this.CountryValues = {};
      this.RetailerValues = {};
      this.DashboardData = null;

      this.setClientSettings(clientSettings);
      this.reloadCurrentTab()
        .then(() => EventBus.$emit("ClientChanged"));
    },

    // ***********************************************************
    // Private methods
    // ***********************************************************
    getClientSettings(clientId) {
      return AdministationService.getClientSettings(clientId || this.ClientSelected)
        .then(response => this.setClientSettings(response?.data?.[0]));
    },

    setClientSettings(clientSettings) {
      if (!clientSettings) return;

      this.ColorRange = clientSettings.Thresholds;
      this.DefaultLogo = clientSettings.LogoExternalImageId
        ? process.env.BASE_URL + `api/media/image?id=${clientSettings.LogoExternalImageId}`
        : process.env.BASE_URL + "static/img/msm_loop_logo_40px.png";
    },

    displayModeChanged(ev) {
      this.pageSize = ev == "tiles" ? 12 : 999
      if(this.showRetailer) {
        this.getRetailer(_, _, this.pageSize);
      }
    }
    // getScoreThresholds(clientId, scoreId) {
    //   DashboardService.getThresholds(clientId, scoreId)
    //   .then(response => {
    //     this.ColorRange = response.data;
    //   });
    // }
  },

  computed: {
    isMSMUser: function() {
      return AuthenticationService.isMSMUser;
    },

    localUserProfile: function () {
      return AuthenticationService.localUserProfile;
    },

    hasFileImport() {
      return APP_TARGET === "jlr";
    },

    isLoading: function() {
      return (
        this.isLoadingSettings ||
        this.isLoadingCountries ||
        this.isLoadingDealer ||
        this.isLoadingRetailer ||
        this.isLoadingExport
      );
    }
  }
};
</script>

<style scoped>
.container {
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 0px;
  padding-right: 0px;
  max-width: 100%;
  width: 100%;
  min-width: 1366px;
}

.card {
  margin-bottom: 20px;
  word-wrap: unset;
}

.card-body {
  min-height: 150px;
}

.excelButton {
  background-color: #107c41;
  border-color: #107c41;
}

.excelButtonTooltip {
  z-index: 1;
  float: right;
  position: relative;
  bottom: -10px;
  right: 3px;
  margin-bottom: -50px;
}

b-dropdown.exportGroup > * {
  background-color: #107c41!important;
  color: #eee!important;
}

.tooltip {
  /* Workaround: https://github.com/bootstrap-vue/bootstrap-vue/issues/1732 */
  top: 0;
}
</style>
<style>
.disabledTab {
  pointer-events: none;
}

.disabledTab > .nav-link {
  pointer-events: none;
  display: none;
  color: rgba(255, 255, 255, 0) !important;
  cursor: not-allowed;
}
</style>
